import { render, staticRenderFns } from "./QText.vue?vue&type=template&id=075d88ae&scoped=true"
import script from "./QText.vue?vue&type=script&lang=js"
export * from "./QText.vue?vue&type=script&lang=js"
import style0 from "./QText.vue?vue&type=style&index=0&id=075d88ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "075d88ae",
  null
  
)

/* custom blocks */
import block0 from "./QText.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

export default component.exports